import React, {forwardRef} from "react";
// core components
import GridItem from "components/Grid/GridItem.js";
// @material-ui/core components
import { makeStyles, TextField, InputAdornment } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  textField: {
    '& label.Mui-focused': {
      color: 'rgb(15, 25, 150)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'rgb(15, 25, 150)',
    },
  }
}))

export const NumberInput = forwardRef((props, ref) => {
  const classes = useStyles()
  // determina valor padrão dos atributos caso nenhum valor seja passado
  const max = props.max ? props.max : 9999999
  const min = props.min ? props.min : 0
  const step = props.step ? props.step : 1
  const fieldsize = props.fieldsize ? props.fieldsize : 12
  const mobilesize = props.mobilesize ? props.mobilesize : 12
  const endadornment = props.endadornment ? props.endadornment : null

  return (
    <GridItem xs={mobilesize} sm={12} md={fieldsize}>
      <TextField className={classes.textField}
                 type="number"
                 inputRef={ref}
                 fullWidth
                 inputProps={{ max: max, min: min, step: step, style: { textAlign: 'center' }}}
                 InputProps={{endAdornment: <InputAdornment position="end">{endadornment || ""}</InputAdornment>}}
                 onChange={(e) => (parseInt(e.target.value, 10))}
                 {...props}/>
    </GridItem>
    )
})
